import translate from '../i18n/config';
import { Modules, AuthRoutes, PermissionActionsEnum, PermissionModulesEnum, RouteParamsTypes } from '../enums';
import { Menu } from '../interfaces/common';
import { getCurrentMonthAndYear } from './methods';


export const TABLE_CONSTANTS = {
  defaultPerPage: 10,
  noRecordsFound: translate.t('common.table.noRecordsFound'),
};

export const STATUS = {
  active: 'ACTIVE',
  inactive: 'INACTIVE',
};

export const Regex = {
  email: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[^A-Za-z0-9\s])\S{8,128}$/,
  floatValues: /^\d+(\.\d{1,2})?$/,
  floatWithNegative: /^-?\d+(\.\d{1,2})?$/,
  percentPattern: /^(?:\d{1,2}(?:\.\d{1,2})?|100(?:\.0{1,2})?)$/,
  website: /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
  code: /^[a-z0-9_]+$/,
};

export const MenuTextMapping = {
  dashboard: 'dashboard',
  resources: 'resources',
  stockists: 'stockists',
  tasks: 'tasks',
  templates: 'templates',
  monthlyStock: 'monthlyStock',
  monthlyStockList: 'monthlyStockList',
  products: 'products',
  logout: 'logout',
  blank: '',
};

export const RoutesMapping = {
  [MenuTextMapping.dashboard]: [AuthRoutes.dashboard],
  [MenuTextMapping.resources]: [AuthRoutes.users, AuthRoutes.stockists],
  [MenuTextMapping.tasks]: [AuthRoutes.tasks],
  [MenuTextMapping.templates]: [AuthRoutes.templates],
  [MenuTextMapping.monthlyStockList]: [AuthRoutes.monthlyStockList],
  [MenuTextMapping.monthlyStock]: [AuthRoutes.monthlyStockList],
};

export const ROUTES_PERMISSIONS_BINDING = {
  users: [
    {
      [PermissionModulesEnum.Users]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
  stockists: [
    {
      [PermissionModulesEnum.Stockists]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
  tasks: [
    {
      [PermissionModulesEnum.Tasks]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
  templates: [
    {
      [PermissionModulesEnum.Templates]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
  monthlyStock: [ // Add this block
    {
      [PermissionModulesEnum.MonthlyStock]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
        PermissionActionsEnum.Import,
      ],
    },
  ],
  productDivisions: [
    {
      [PermissionModulesEnum.ProductDivisions]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
      ],
    },
  ],
  products: [
    {
      [PermissionModulesEnum.Products]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
      ],
    },
  ],
};

export const Menus: Menu[] = [
  {
    text: translate.t('layout.pageTexts.menus.dashboard'),
    id: MenuTextMapping.dashboard,
    redirectsTo: Modules.home + AuthRoutes.dashboard,
    icon: <i className="menu-icon tf-icons ri-home-smile-line"></i>,
  },
  {
    text: translate.t('layout.pageTexts.menus.monthlyStock'),
    id: MenuTextMapping.monthlyStock,
    redirectsTo: Modules.monthlyStock + AuthRoutes.monthlyStockList,
    icon: <i className="menu-icon tf-icons ri-file-list-3-line"></i>,
    accessibleTo: ROUTES_PERMISSIONS_BINDING.monthlyStock,
  },
  {
    text: translate.t('layout.pageTexts.menus.templates'),
    id: MenuTextMapping.templates,
    redirectsTo: Modules.templates + AuthRoutes.templates,
    icon: <i className="menu-icon tf-icons ri-file-settings-line"></i>,
    accessibleTo: ROUTES_PERMISSIONS_BINDING.templates,
  },
  {
    text: translate.t('layout.pageTexts.menus.resources.root'),
    id: MenuTextMapping.resources,
    icon: <i className="menu-icon tf-icons ri-user-line"></i>,
    childrens: [
      {
        text: translate.t('layout.pageTexts.menus.resources.users'),
        redirectsTo: Modules.resources + AuthRoutes.users,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.users,
      },
      {
        text: translate.t('layout.pageTexts.menus.resources.stockists'),
        redirectsTo: Modules.resources + AuthRoutes.stockists,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.stockists,
      },
    ],
  },
  {
    text: translate.t('layout.pageTexts.menus.products'),
    id: MenuTextMapping.products,
    icon: <i className="menu-icon tf-icons ri-capsule-line"></i>,
    childrens: [
      {
        text: translate.t('layout.pageTexts.menus.productDivisions'),
        redirectsTo: Modules.products + AuthRoutes.productDivisions,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.productDivisions,
      },
      {
        text: translate.t('layout.pageTexts.menus.productsMaster'),
        redirectsTo: Modules.products + AuthRoutes.products,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.products,
      },
    ],
  },
];

export const VALIDATION_FIELD_MAPPING = {
  username: 'username',
  first_name: 'first_name',
  password: 'password',
  email: 'email',
  oldPassword: 'oldPassword',
  newPassword: 'newPassword',
  confirmPassword: 'confirmPassword',
  role: 'role',
  manager: 'manager',
  updated_at: 'updated_at',
  actions: 'actions',
  searchText: 'searchText',
  changed_at: 'changed_at',
  changer_name: 'changer_name',
  field_name: 'field_name',
  old_value: 'old_value',
  new_value: 'new_value',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  phoneCountryCode: 'phoneCountryCode',
  emergencyPhone: 'emergencyPhone',
  emergencyPhoneCountryCode: 'emergencyPhoneCountryCode',
  countryCode: 'countryCode',
  order_by: 'order_by',
  name: 'name',
  address: 'address',
  status: 'status',
  currentPassword: 'currentPassword',
  vendorId: 'vendorId',
  updatedAt: 'updatedAt',
  serviceType: 'serviceTypeId',
  addressCity: 'addressCity',
  addressState: 'addressState',
  addressPostcode: 'addressPostcode',
  addressCountry: 'addressCountry',
  serviceRate: 'serviceRate',
  notes: 'notes',
  title: 'title',
  description: 'description',
  priority: 'priority',
  due_date: 'due_date',
  salutation: 'salutation',
  city: 'city',
  state: 'state',
  pincode: 'pincode',
  contactNumber: 'contactNumber',
  primaryContactPerson: 'primaryContactPerson',
  primaryContactNumber: 'primaryContactNumber',
  primaryContactEmail: 'primaryContactEmail',
  website: 'website',
  gstNumber: 'gstNumber',
  fileType: 'fileType',
  template: 'template',
  file: 'file',
  templateHeader: 'templateHeader',
  textboxMapping: 'textboxMapping',
  mrUser: 'mrUser',
  code: 'code',
  product_division_id: 'product_division_id',
  product_division: 'product_division',
  modify_date: 'modify_date',
  month: 'month',
  year: 'year',
  stockist: 'stockist',
  branch: 'branch',
  uploadedBy: 'uploadedBy',
  user: 'user',
  stockist_product: 'stockist_product',
  op_qty: 'op_qty',
  op_qty_value: 'op_qty_value',
  received_qty: 'received_qty',
  received_qty_value: 'received_qty_value',
  issued_qty: 'issued_qty',
  issued_qty_value: 'issued_qty_value',
  closing_qty: 'closing_qty',
  closing_qty_value: 'closing_qty_value',
  company_product: 'company_product',
  mapping: 'status',
  stockistProduct: 'stockistProduct',
  opQty: 'opQty',
  opVal: 'opVal',
  purQty: 'purQty',
  purVal: 'purVal',
  salesQty: 'salesQty',
  salesVal: 'salesVal',
  clQty: 'clQty',
  clVal: 'clVal',
  mappedTo: 'mappedTo',
  comment: 'comment',
  mappingDivision: 'mappingDivision',
  showUnmatchedOnly: 'showUnmatchedOnly',
  zone: 'zone',
  secondary: 'secondary',
  closing: 'closing',
};

export const HEAD_CELL_SORT_DISABLED = {
  userList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.manager,
    VALIDATION_FIELD_MAPPING.role,
  ],
  taskList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.status,
    VALIDATION_FIELD_MAPPING.priority,
  ],
  stockistList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.zone,
  ],
  stockistBranchList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
  stockistProductList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
  templateList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
  templateHeaderMappingList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.templateHeader,
    VALIDATION_FIELD_MAPPING.textboxMapping,
  ],
  productDivisionList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
  productList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
  monthlyStockList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.uploadedBy,
  ],
  monthlyStockVerifyList: [],
  zoneWiseList: [
    VALIDATION_FIELD_MAPPING.zone,
    VALIDATION_FIELD_MAPPING.secondary,
    VALIDATION_FIELD_MAPPING.closing,
  ],
  productSuggestionList: [
    VALIDATION_FIELD_MAPPING.name,
    VALIDATION_FIELD_MAPPING.product_division,
    VALIDATION_FIELD_MAPPING.actions,
  ],
};

export const HEAD_CELL_LABELS_MAPPING = {
  userList: {
    [VALIDATION_FIELD_MAPPING.first_name]: translate.t('users.list.pageTexts.table.columns.user'),
    [VALIDATION_FIELD_MAPPING.role]: translate.t('users.list.pageTexts.table.columns.role'),
    [VALIDATION_FIELD_MAPPING.manager]: translate.t('users.list.pageTexts.table.columns.manager'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('users.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.updated_at]: translate.t(
      'users.list.pageTexts.table.columns.updatedAt'
    ),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('users.list.pageTexts.table.columns.actions'),
  },
  taskList: {
    [VALIDATION_FIELD_MAPPING.title]: translate.t('tasks.list.pageTexts.table.columns.title'),
    [VALIDATION_FIELD_MAPPING.description]: translate.t(
      'tasks.list.pageTexts.table.columns.description'
    ),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('tasks.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.priority]: translate.t('tasks.list.pageTexts.table.columns.priority'),
    [VALIDATION_FIELD_MAPPING.due_date]: translate.t('tasks.list.pageTexts.table.columns.dueDate'),
    [VALIDATION_FIELD_MAPPING.updated_at]: translate.t(
      'tasks.list.pageTexts.table.columns.updatedAt'
    ),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('tasks.list.pageTexts.table.columns.actions'),
  },
  stockistList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('stockists.list.pageTexts.table.columns.name') || 'Name',
    [VALIDATION_FIELD_MAPPING.zone]: translate.t('stockists.list.pageTexts.table.columns.zone') || 'Zone',
    [VALIDATION_FIELD_MAPPING.city]: translate.t('stockists.list.pageTexts.table.columns.city') || 'City',
    [VALIDATION_FIELD_MAPPING.state]: translate.t('stockists.list.pageTexts.table.columns.state') || 'State',
    [VALIDATION_FIELD_MAPPING.email]: translate.t('stockists.list.pageTexts.table.columns.email') || 'Email',
    [VALIDATION_FIELD_MAPPING.status]: translate.t('stockists.list.pageTexts.table.columns.status') || 'Status',
    [VALIDATION_FIELD_MAPPING.updated_at]: translate.t('stockists.list.pageTexts.table.columns.updatedAt') || 'Last Updated',
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('stockists.list.pageTexts.table.columns.actions') || 'Actions',
  },
  stockistBranchList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.name') || 'Branch Name',
    [VALIDATION_FIELD_MAPPING.city]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.city') || 'City',
    [VALIDATION_FIELD_MAPPING.state]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.state') || 'State',
    [VALIDATION_FIELD_MAPPING.email]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.email') || 'Email',
    [VALIDATION_FIELD_MAPPING.status]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.status') || 'Status',
    [VALIDATION_FIELD_MAPPING.updated_at]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.updatedAt') || 'Last Updated',
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('stockists.stockistBranch.list.pageTexts.table.columns.actions') || 'Actions',
  },
  stockistProductList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('stockists.stockistProduct.list.pageTexts.table.columns.name') || 'Product Name',
    [VALIDATION_FIELD_MAPPING.description]: translate.t('stockists.stockistProduct.list.pageTexts.table.columns.description') || 'Description',
    [VALIDATION_FIELD_MAPPING.status]: translate.t('stockists.stockistProduct.list.pageTexts.table.columns.status') || 'Status',
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('stockists.stockistProduct.list.pageTexts.table.columns.actions') || 'Actions',
  },
  templateList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('templates.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.fileType]: translate.t('templates.list.pageTexts.table.columns.fileType'),
    [VALIDATION_FIELD_MAPPING.description]: translate.t('templates.list.pageTexts.table.columns.description'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('templates.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('templates.list.pageTexts.table.columns.actions'),
  },
  templateHeaderMappingList: {
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('templates.addEdit.pageTexts.table.columns.actions') || 'Actions',
    [VALIDATION_FIELD_MAPPING.templateHeader]: translate.t('templates.addEdit.pageTexts.table.columns.templateHeader'),
    [VALIDATION_FIELD_MAPPING.textboxMapping]: translate.t('templates.addEdit.pageTexts.table.columns.textboxMapping'),
  },
  productDivisionList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('productDivisions.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.description]: translate.t('productDivisions.list.pageTexts.table.columns.description'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('productDivisions.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('productDivisions.list.pageTexts.table.columns.actions'),
  },
  productList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('products.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.description]: translate.t('products.list.pageTexts.table.columns.description'),
    [VALIDATION_FIELD_MAPPING.product_division]: translate.t('products.list.pageTexts.table.columns.division'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('products.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.modify_date]: translate.t('products.list.pageTexts.table.columns.lastUpdated'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('products.list.pageTexts.table.columns.actions'),
  },
  monthlyStockList: {
    [VALIDATION_FIELD_MAPPING.month]: translate.t('monthlyStock.list.pageTexts.table.columns.month'),
    [VALIDATION_FIELD_MAPPING.stockist]: translate.t('monthlyStock.list.pageTexts.table.columns.stockist'),
    [VALIDATION_FIELD_MAPPING.branch]: translate.t('monthlyStock.list.pageTexts.table.columns.branch'),
    [VALIDATION_FIELD_MAPPING.template]: translate.t('monthlyStock.list.pageTexts.table.columns.template'),
    [VALIDATION_FIELD_MAPPING.uploadedBy]: translate.t('monthlyStock.list.pageTexts.table.columns.uploadedBy'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('monthlyStock.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('monthlyStock.list.pageTexts.table.columns.actions'),
  },
  productSuggestionList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.mapModal.suggestionColumns.product'),
    [VALIDATION_FIELD_MAPPING.product_division]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.mapModal.suggestionColumns.division'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.mapModal.suggestionColumns.actions'),
  },
  monthlyStockVerifyList: {
    [VALIDATION_FIELD_MAPPING.stockist_product]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.product'),
    [VALIDATION_FIELD_MAPPING.op_qty]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.openingQty'),
    [VALIDATION_FIELD_MAPPING.op_qty_value]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.openingValue'),
    [VALIDATION_FIELD_MAPPING.received_qty]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.receiveQty'),
    [VALIDATION_FIELD_MAPPING.received_qty_value]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.receiveValue'),
    [VALIDATION_FIELD_MAPPING.issued_qty]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.issueQty'),
    [VALIDATION_FIELD_MAPPING.issued_qty_value]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.issueValue'),
    [VALIDATION_FIELD_MAPPING.closing_qty]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.closingQty'),
    [VALIDATION_FIELD_MAPPING.closing_qty_value]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.closingValue'),
    [VALIDATION_FIELD_MAPPING.company_product]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.companyProduct'),
    [VALIDATION_FIELD_MAPPING.mapping]: translate.t('monthlyStock.addEdit.pageTexts.verifyData.table.columns.mapping'),
  },
  zoneWiseList: {
    [VALIDATION_FIELD_MAPPING.zone]: translate.t('dashboard.pageTexts.zoneWise.zone'),
    [VALIDATION_FIELD_MAPPING.secondary]: translate.t('dashboard.pageTexts.zoneWise.secondary'),
    [VALIDATION_FIELD_MAPPING.closing]: translate.t('dashboard.pageTexts.zoneWise.closing'),
  },
};

export const HEAD_CELL_SORT_MAPPING = {
  userList: {
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
    [VALIDATION_FIELD_MAPPING.updated_at]: 'modify_date',
  },
  taskList: {
    [VALIDATION_FIELD_MAPPING.status]: 'status',
    [VALIDATION_FIELD_MAPPING.priority]: 'priority',
    [VALIDATION_FIELD_MAPPING.due_date]: 'due_date',
    [VALIDATION_FIELD_MAPPING.updated_at]: 'updated_at',
  },
  stockistList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.zone]: 'zone',
    [VALIDATION_FIELD_MAPPING.city]: 'city',
    [VALIDATION_FIELD_MAPPING.state]: 'state',
    [VALIDATION_FIELD_MAPPING.email]: 'email',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
    [VALIDATION_FIELD_MAPPING.updated_at]: 'modify_date',
  },
  stockistBranchList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.city]: 'city',
    [VALIDATION_FIELD_MAPPING.state]: 'state',
    [VALIDATION_FIELD_MAPPING.email]: 'email',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
    [VALIDATION_FIELD_MAPPING.updated_at]: 'modify_date',
  },
  stockistProductList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.description]: 'description',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
  },
  templateList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.fileType]: 'extension',
    [VALIDATION_FIELD_MAPPING.description]: 'description',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
  },
  productDivisionList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.description]: 'description',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
  },
  productList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.description]: 'description',
    [VALIDATION_FIELD_MAPPING.product_division]: 'product_division',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
    [VALIDATION_FIELD_MAPPING.modify_date]: 'modify_date',
  },
  monthlyStockList: {
    [VALIDATION_FIELD_MAPPING.month]: 'month',
    [VALIDATION_FIELD_MAPPING.stockist]: 'stockist_name',
    [VALIDATION_FIELD_MAPPING.branch]: 'branch_name',
    [VALIDATION_FIELD_MAPPING.template]: 'template_name',
    [VALIDATION_FIELD_MAPPING.status]: 'status',
  },
  monthlyStockVerifyList: {},
  zoneWiseList: {},
};

export const HEAD_CELL_WIDTH_MAPPING = {
  userList: {
    [VALIDATION_FIELD_MAPPING.first_name]: '25%',
    [VALIDATION_FIELD_MAPPING.role]: '15%',
    [VALIDATION_FIELD_MAPPING.manager]: '20%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.updated_at]: '20%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  taskList: {
    [VALIDATION_FIELD_MAPPING.title]: '20%',
    [VALIDATION_FIELD_MAPPING.description]: '25%',
    [VALIDATION_FIELD_MAPPING.status]: '12%',
    [VALIDATION_FIELD_MAPPING.priority]: '12%',
    [VALIDATION_FIELD_MAPPING.due_date]: '15%',
    [VALIDATION_FIELD_MAPPING.updated_at]: '16%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  stockistList: {
    [VALIDATION_FIELD_MAPPING.name]: '18%',
    [VALIDATION_FIELD_MAPPING.zone]: '10%',
    [VALIDATION_FIELD_MAPPING.city]: '12%',
    [VALIDATION_FIELD_MAPPING.state]: '12%',
    [VALIDATION_FIELD_MAPPING.email]: '20%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.updated_at]: '13%',
    [VALIDATION_FIELD_MAPPING.actions]: '5%',
  },
  stockistBranchList: {
    [VALIDATION_FIELD_MAPPING.name]: '20%',
    [VALIDATION_FIELD_MAPPING.city]: '15%',
    [VALIDATION_FIELD_MAPPING.state]: '15%',
    [VALIDATION_FIELD_MAPPING.email]: '20%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.updated_at]: '15%',
    [VALIDATION_FIELD_MAPPING.actions]: '5%',
  },
  stockistProductList: {
    [VALIDATION_FIELD_MAPPING.name]: '30%',
    [VALIDATION_FIELD_MAPPING.description]: '45%',
    [VALIDATION_FIELD_MAPPING.status]: '15%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  templateList: {
    [VALIDATION_FIELD_MAPPING.name]: '25%',
    [VALIDATION_FIELD_MAPPING.fileType]: '15%',
    [VALIDATION_FIELD_MAPPING.description]: '40%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  templateHeaderMappingList: {
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
    [VALIDATION_FIELD_MAPPING.templateHeader]: '40%',
    [VALIDATION_FIELD_MAPPING.textboxMapping]: '50%',
  },
  productDivisionList: {
    [VALIDATION_FIELD_MAPPING.name]: '25%',
    [VALIDATION_FIELD_MAPPING.description]: '50%',
    [VALIDATION_FIELD_MAPPING.status]: '15%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  productList: {
    [VALIDATION_FIELD_MAPPING.name]: '20%',
    [VALIDATION_FIELD_MAPPING.description]: '25%',
    [VALIDATION_FIELD_MAPPING.product_division]: '18%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.modify_date]: '17%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  monthlyStockList: {
    [VALIDATION_FIELD_MAPPING.month]: '10%',
    [VALIDATION_FIELD_MAPPING.stockist]: '20%',
    [VALIDATION_FIELD_MAPPING.branch]: '15%',
    [VALIDATION_FIELD_MAPPING.template]: '15%',
    [VALIDATION_FIELD_MAPPING.uploadedBy]: '15%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.actions]: '15%',
  },
  productSuggestionList: {
    [VALIDATION_FIELD_MAPPING.name]: '45%',
    [VALIDATION_FIELD_MAPPING.product_division]: '40%',
    [VALIDATION_FIELD_MAPPING.actions]: '15%',
  },
  zoneWiseList: {
    [VALIDATION_FIELD_MAPPING.zone]: '34%',
    [VALIDATION_FIELD_MAPPING.secondary]: '33%',
    [VALIDATION_FIELD_MAPPING.closing]: '33%',
  },
  monthlyStockVerifyList: {
    [VALIDATION_FIELD_MAPPING.stockist_product]: '28%',
    [VALIDATION_FIELD_MAPPING.op_qty]: '9%',
    [VALIDATION_FIELD_MAPPING.op_qty_value]: '10%',
    [VALIDATION_FIELD_MAPPING.received_qty]: '9%',
    [VALIDATION_FIELD_MAPPING.received_qty_value]: '10%',
    [VALIDATION_FIELD_MAPPING.issued_qty]: '9%',
    [VALIDATION_FIELD_MAPPING.issued_qty_value]: '9%',
    [VALIDATION_FIELD_MAPPING.closing_qty]: '9%',
    [VALIDATION_FIELD_MAPPING.closing_qty_value]: '10%',
    [VALIDATION_FIELD_MAPPING.company_product]: '200px',
    [VALIDATION_FIELD_MAPPING.mapping]: '60px',
  },
};

export const APP_ERROR_MESSAGES = {
  login: {
    blankUsername: translate.t('login.pageTexts.form.username.errors.required'),
    invalidUsername: translate.t('login.pageTexts.form.username.errors.invalid'),
    blankPassword: translate.t('login.pageTexts.form.password.errors.required'),
    shortPassword: translate.t('login.pageTexts.form.password.errors.lengthShort'),
    longPassword: translate.t('login.pageTexts.form.password.errors.lengthLong'),
  },
  forgotPassword: {
    blankEmail: translate.t('forgotPassword.pageTexts.form.email.errorMessage'),
  },
  resetPassword: {
    blankNewPassword: translate.t('resetPassword.pageTexts.form.newPassword.errors.required'),
    mismatchNewPassword: translate.t('resetPassword.pageTexts.form.newPassword.errors.mismatch'),
    blankConfirmPassword: translate.t(
      'resetPassword.pageTexts.form.confirmPassword.errors.required'
    ),
    mismatchConfirmPassword: translate.t(
      'resetPassword.pageTexts.form.confirmPassword.errors.mismatch'
    ),
    passwordFormat: translate.t('resetPassword.pageTexts.form.newPassword.errors.passwordFormat'),
  },
  users: {
    addEdit: {
      blankFirstName: translate.t('users.addEdit.pageTexts.form.firstName.errors.required'),
      blankLastName: translate.t('users.addEdit.pageTexts.form.lastName.errors.required'),
      blankEmail: translate.t('users.addEdit.pageTexts.form.email.errors.required'),
      invalidEmail: translate.t('users.addEdit.pageTexts.form.email.errors.invalid'),
      blankPhoneNumber: translate.t('users.addEdit.pageTexts.form.phoneNumber.errors.required'),
      blankRole: translate.t('users.addEdit.pageTexts.form.role.errors.required'),
      blankSalutation: translate.t('users.addEdit.pageTexts.form.salutation.errors.required'),
      blankPassword: translate.t('users.addEdit.pageTexts.form.password.errors.required'),
      invalidPassword: translate.t('users.addEdit.pageTexts.form.password.errors.invalid'),
    },
    changePassword: {
      blankCurrentPassword: translate.t(
        'changePassword.pageTexts.form.currentPassword.errors.required'
      ),
      blankNewPassword: translate.t('changePassword.pageTexts.form.newPassword.errors.required'),
      passwordFormat: translate.t(
        'changePassword.pageTexts.form.newPassword.errors.passwordFormat'
      ),
      blankConfirmPassword: translate.t(
        'changePassword.pageTexts.form.confirmPassword.errors.required'
      ),
      passwordsDoNotMatch: translate.t(
        'changePassword.pageTexts.form.confirmPassword.errors.mismatch'
      ),
    },
  },
  tasks: {
    addEdit: {
      blankTitle: translate.t('tasks.addEdit.pageTexts.form.title.errors.required'),
      blankDescription: translate.t('tasks.addEdit.pageTexts.form.description.errors.required'),
      blankStatus: translate.t('tasks.addEdit.pageTexts.form.status.errors.required'),
      blankPriority: translate.t('tasks.addEdit.pageTexts.form.priority.errors.required'),
      blankDueDate: translate.t('tasks.addEdit.pageTexts.form.dueDate.errors.required'),
      invalidDueDate: translate.t('tasks.addEdit.pageTexts.form.dueDate.errors.invalid'),
    },
  },
  vendors: {
    addEdit: {
      blankCompanyName: translate.t('vendor.addEdit.pageTexts.form.companyName.errors.required'),
      blankVendorName: translate.t('vendor.addEdit.pageTexts.form.name.errors.required'),
      blankServiceType: translate.t('vendor.addEdit.pageTexts.form.serviceType.errors.required'),
      blankPhoneNumber: translate.t('vendor.addEdit.pageTexts.form.phoneNumber.errors.required'),
      invalidEmail: translate.t('vendor.addEdit.pageTexts.form.email.errors.invalid'),
      blankServiceRate: translate.t('vendor.addEdit.pageTexts.form.serviceRate.errors.required'),
      invalidServiceRate: translate.t('vendor.addEdit.pageTexts.form.serviceRate.errors.invalid'),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  customers: {
    addEdit: {
      blankCustomerName: translate.t('customers.addEdit.pageTexts.form.customer.errors.required'),
      blankPrimaryFirstName: translate.t(
        'customers.addEdit.pageTexts.form.primaryFirstName.errors.required'
      ),
      blankPrimaryLastName: translate.t(
        'customers.addEdit.pageTexts.form.primaryLastName.errors.required'
      ),
      blankPrimaryEmail: translate.t(
        'customers.addEdit.pageTexts.form.primaryEmail.errors.required'
      ),
      invalidPrimaryEmail: translate.t(
        'customers.addEdit.pageTexts.form.primaryEmail.errors.invalid'
      ),
      invalidSecondaryEmail: translate.t(
        'customers.addEdit.pageTexts.form.secondaryEmail.errors.invalid'
      ),
      blankCountryCode: translate.t('customers.addEdit.pageTexts.form.countryCode.errors.required'),
      blankDisplayName: translate.t('customers.addEdit.pageTexts.form.displayName.errors.required'),
      blankBillingCurrency: translate.t(
        'customers.addEdit.pageTexts.form.billingCurrency.errors.required'
      ),
      blankPhoneNumber: translate.t('customers.addEdit.pageTexts.form.phoneNumber.errors.required'),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  property: {
    addEdit: {
      blankCustomer: translate.t('property.addEdit.pageTexts.form.customer.errors.required'),
      blankPropertyName: translate.t('property.addEdit.pageTexts.form.name.errors.required'),
      blankPublicName: translate.t('property.addEdit.pageTexts.form.publicName.errors.required'),
      blankHospitableId: translate.t(
        'property.addEdit.pageTexts.form.hospitableId.errors.required'
      ),
      invalidPictureUrl: translate.t('property.addEdit.pageTexts.form.pictureUrl.errors.invalid'),
      blankManagedBy: translate.t('property.addEdit.pageTexts.form.managedBy.errors.required'),
      blankCleaningManagedBy: translate.t(
        'property.addEdit.pageTexts.form.cleaningManagedBy.errors.required'
      ),
      blankWhoCollectsMoney: translate.t(
        'property.addEdit.pageTexts.form.whoCollectsMoney.errors.required'
      ),
      blankWhoCollectsHst: translate.t(
        'property.addEdit.pageTexts.form.whoCollectsHst.errors.required'
      ),
      blankAddress: translate.t('property.addEdit.pageTexts.form.address1.errors.required'),
      blankCity: translate.t('property.addEdit.pageTexts.form.city.errors.required'),
      blankState: translate.t('property.addEdit.pageTexts.form.state.errors.required'),
      blankPostcode: translate.t('property.addEdit.pageTexts.form.postal.errors.required'),
      blankCountry: translate.t('property.addEdit.pageTexts.form.country.errors.required'),
      blankBookingType: translate.t('property.addEdit.pageTexts.form.bookingType.errors.required'),
      blankCommissionPercentage: translate.t(
        'property.addEdit.pageTexts.form.commission.errors.required'
      ),
      blankMaintenanceDetails: translate.t(
        'property.addEdit.pageTexts.form.maintenanceDetails.errors.required'
      ),
      invalidCommissionPercentage: translate.t(
        'property.addEdit.pageTexts.form.commission.errors.invalid'
      ),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
      pictureUrlMaxLengthExceeded: translate.t('common.maxLength.errors.pictureUrlExceeded'),
    },
  },
  transactions: {
    addEdit: {
      blankTransactionDate: translate.t(
        'transactions.addEdit.pageTexts.form.transactionDate.errors.required'
      ),
      blankProperty: translate.t('transactions.addEdit.pageTexts.form.property.errors.required'),
      blankDebitCredit: translate.t(
        'transactions.addEdit.pageTexts.form.debitCredit.errors.required'
      ),
      blankTransactionType: translate.t(
        'transactions.addEdit.pageTexts.form.transactionType.errors.required'
      ),
      blankReviewedBy: translate.t(
        'transactions.addEdit.pageTexts.form.reviewedBy.errors.required'
      ),
      invalidActualCost: translate.t(
        'transactions.addEdit.pageTexts.form.actualCost.errors.invalid'
      ),
      blankTotalAmount: translate.t(
        'transactions.addEdit.pageTexts.form.totalAmount.errors.required'
      ),
      invalidTotalAmount: translate.t(
        'transactions.addEdit.pageTexts.form.totalAmount.errors.invalid'
      ),
      blankSubTotal: translate.t('transactions.addEdit.pageTexts.form.subTotal.errors.required'),
      invalidSubTotal: translate.t('transactions.addEdit.pageTexts.form.subTotal.errors.invalid'),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  reservations: {
    edit: {
      blankCheckInDate: translate.t('reservations.edit.pageTexts.form.checkInDate.errors.required'),
      blankCheckOutDate: translate.t(
        'reservations.edit.pageTexts.form.checkOutDate.errors.required'
      ),
      blankReviewedBy: translate.t('reservations.edit.pageTexts.form.reviewedBy.errors.required'),
      invalidXNightRoomFees: translate.t(
        'reservations.edit.pageTexts.form.xNightRoomFees.errors.invalid'
      ),
      invalidPerNightFees: translate.t(
        'reservations.edit.pageTexts.form.perNightFees.errors.invalid'
      ),
      invalidCleaningFees: translate.t(
        'reservations.edit.pageTexts.form.cleaningFees.errors.invalid'
      ),
      invalidLinenFees: translate.t('reservations.edit.pageTexts.form.linenFees.errors.invalid'),
      invalidPetFees: translate.t('reservations.edit.pageTexts.form.petFees.errors.invalid'),
      invalidHostFees: translate.t('reservations.edit.pageTexts.form.hostFees.errors.invalid'),
      invalidDiscount: translate.t('reservations.edit.pageTexts.form.discount.errors.invalid'),
      invalidMatTax: translate.t('reservations.edit.pageTexts.form.matTax.errors.invalid'),
      invalidHstTax: translate.t('reservations.edit.pageTexts.form.hstTax.errors.invalid'),
      invalidAdjustments: translate.t(
        'reservations.edit.pageTexts.form.adjustments.errors.invalid'
      ),
      invalidHostPayout: translate.t('reservations.edit.pageTexts.form.hostPayout.errors.invalid'),
      invalidActualRevenue: translate.t(
        'reservations.edit.pageTexts.form.actualRevenue.errors.invalid'
      ),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  invoices: {
    addList: {
      blankProperty: translate.t('invoices.addList.pageTexts.form.property.errors.required'),
      blankMonth: translate.t('invoices.addList.pageTexts.form.month.errors.required'),
      blankYear: translate.t('invoices.addList.pageTexts.form.year.errors.required'),
    },
    editPreviewPayment: {
      blankDate: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.date.errors.required'
      ),
      blankAmount: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.amount.errors.required'
      ),
      invalidAmount: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.amount.errors.invalid'
      ),
      blankMethod: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.method.errors.required'
      ),
      blankAccount: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.account.errors.required'
      ),
      blankNotes: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.notes.errors.required'
      ),
      blankReviewedBy: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.detailsTab.otherDetails.reviewedBy.errors.required'
      ),
    },
  },
  stockists: {
    addEdit: {
      blankName: translate.t('stockists.addEdit.pageTexts.form.name.errors.required'),
      blankEmail: translate.t('stockists.addEdit.pageTexts.form.email.errors.required'),
      invalidEmail: translate.t('stockists.addEdit.pageTexts.form.email.errors.invalid'),
      blankAddress: translate.t('stockists.addEdit.pageTexts.form.address.errors.required'),
      blankZone: translate.t('stockists.addEdit.pageTexts.form.zone.errors.required'),
      blankCity: translate.t('stockists.addEdit.pageTexts.form.city.errors.required'),
      blankState: translate.t('stockists.addEdit.pageTexts.form.state.errors.required'),
      blankPincode: translate.t('stockists.addEdit.pageTexts.form.pincode.errors.required'),
      blankWebsite: translate.t('stockists.addEdit.pageTexts.form.website.errors.required'),
      invalidWebsite: translate.t('stockists.addEdit.pageTexts.form.website.errors.invalid'),
      blankGST: translate.t('stockists.addEdit.pageTexts.form.gst.errors.required'),
      blankPrimaryContactPerson: translate.t('stockists.addEdit.pageTexts.form.primaryContactPerson.errors.required'),
      blankPrimaryContactNumber: translate.t('stockists.addEdit.pageTexts.form.primaryContactNumber.errors.required'),
      blankPrimaryContactEmail: translate.t('stockists.addEdit.pageTexts.form.primaryContactEmail.errors.required'),
      invalidPrimaryContactEmail: translate.t('stockists.addEdit.pageTexts.form.primaryContactEmail.errors.invalid'),
      blankTemplate: translate.t('stockists.stockistBranch.addEdit.pageTexts.form.template.errors.required'),
      blankMrUser: translate.t('stockists.stockistBranch.addEdit.pageTexts.form.mrUser.errors.required'),
    },
  },
  stockistProducts: {
    addEdit: {
      blankName: translate.t('stockists.stockistProduct.addEdit.pageTexts.form.name.errors.required'),
      blankDescription: translate.t('stockists.stockistProduct.addEdit.pageTexts.form.description.errors.required'),
    },
  },
  monthlyStock: {
    addEdit: {
      blankStockist: translate.t('monthlyStock.addEdit.pageTexts.form.errors.stockist.required'),
      blankBranch: translate.t('monthlyStock.addEdit.pageTexts.form.errors.branch.required'),
      blankMonth: translate.t('monthlyStock.addEdit.pageTexts.form.errors.month.required'),
      blankYear: translate.t('monthlyStock.addEdit.pageTexts.form.errors.year.required'),
      blankFile: translate.t('monthlyStock.addEdit.pageTexts.form.errors.file.required'),
      invalidFileType: translate.t('monthlyStock.addEdit.pageTexts.form.errors.file.invalidType'),
    },
  },
};

export const APP_SUCCESS_MESSAGES = {
  userCreated: translate.t('users.addEdit.pageTexts.form.addSuccess'),
  userUpdated: translate.t('users.addEdit.pageTexts.form.editSuccess'),
  taskCreated: translate.t('tasks.addEdit.pageTexts.form.addSuccess'),
  taskUpdated: translate.t('tasks.addEdit.pageTexts.form.editSuccess'),
  stockistCreated: translate.t('stockists.addEdit.pageTexts.form.addSuccess'),
  stockistUpdated: translate.t('stockists.addEdit.pageTexts.form.editSuccess'),
  stockistBranchCreated: translate.t('stockists.stockistBranch.addEdit.pageTexts.form.addSuccess'),
  stockistBranchUpdated: translate.t('stockists.stockistBranch.addEdit.pageTexts.form.editSuccess'),
  stockistProductCreated: translate.t('stockists.stockistProduct.addEdit.pageTexts.form.addSuccess'),
  stockistProductUpdated: translate.t('stockists.stockistProduct.addEdit.pageTexts.form.editSuccess'),
  vendorCreated: translate.t('vendor.addEdit.pageTexts.form.addSuccess'),
  vendorUpdated: translate.t('vendor.addEdit.pageTexts.form.editSuccess'),
  customerCreated: translate.t('customers.addEdit.pageTexts.form.addSuccess'),
  customerUpdated: translate.t('customers.addEdit.pageTexts.form.editSuccess'),
  propertyCreated: translate.t('property.addEdit.pageTexts.form.addSuccess'),
  propertyUpdated: translate.t('property.addEdit.pageTexts.form.editSuccess'),
  transactionCreated: translate.t('transactions.addEdit.pageTexts.form.addSuccess'),
  transactionUpdated: translate.t('transactions.addEdit.pageTexts.form.editSuccess'),
  reservationUpdated: translate.t('reservations.edit.pageTexts.form.editSuccess'),
  invoiceDetailsUpdated: translate.t(
    'invoices.editPreviewPayment.pageTexts.form.detailsTab.editSuccess'
  ),
  syncReservationDispatched: translate.t('reservations.list.pageTexts.syncDispatchedSuccess'),
  changePassword: translate.t('changePassword.pageTexts.form.success'),
  forgotPassword: translate.t('forgotPassword.pageTexts.form.success'),
  resetPassword: translate.t('resetPassword.pageTexts.form.success'),
  propertyAssigned: translate.t('users.addEdit.pageTexts.form.propertyAssignSuccess'),
  userAssigned: translate.t('property.addEdit.pageTexts.form.userAssignSuccess'),
  invoiceCreated: translate.t('invoices.addList.pageTexts.form.addSuccess'),
  headerMappingUpdated: translate.t('templates.addEdit.pageTexts.form.headerMappingSuccess'),
};

export const MaxLength = {
  login: {
    password: 128,
  },
  pageSize: 200,
  common: 100,
  pictureUrl: 250,
};

export const MinLength = {
  login: {
    password: 8,
  },
};

export const LOCAL_STORAGE_KEYS: any = {
  loggedInUser: 'loggedInUser',
  token: 'token',
  theme: 'theme',
  permissions: 'permissions',
  isSystemAdmin: 'isSystemAdmin',
  exception: 'exception',
  loading: 'loading',
  tenantInfo: 'tenantInfo',
};

export const GENERIC_LOOKUP_KEYS = {
  status: 'status',
  salutation: 'salutation',
  billingCurrency: 'billing_currency',
  propertyBookingType: 'property_booking_type',
  whoCollectsMoney: 'who_collects_money',
  whoCollectsHst: 'who_collects_hst',
  transactionType: 'transaction_type',
  debitCredit: 'crdr',
  hstPercentage: 'tax',
  transactionStatus: 'transaction_status',
  crdr: 'crdr',
  reservationStatus: 'reservation_status',
  invoiceStatus: 'invoice_status',
  source: 'source',
  stockStatus: 'stock_status',
  linkedWithHospitable: 'yes_no',
  month: 'month',
  paymentDate: 'payment_date',
  paymentAmount: 'payment_amount',
  paymentType: 'payment_type',
  paymentMethod: 'payment_method',
  paymentAccount: 'payment_account',
  fileType: 'file_type',
};

export const DEFAULTS = {
  country: '1',
  state: '1',
  currency: 'CAD',
  status: 'unbilled',
  statusLabel: 'Unbilled',
  debit: 'dr',
  hst: '13',
  paymentType: 'received',
  month: () => getCurrentMonthAndYear().month,
  year: () => getCurrentMonthAndYear().year,
  mrRole: 'MR',
};

export const VALIDATION_TYPE = {
  email: 'EMAIL',
};

export const RESERVATION_STATUS = {
  accepted: 'accepted',
  expired: 'expired',
  cancelled: 'cancelled',
  unbilled: 'unbilled',
  reconciled: 'reconciled',
};

export const TRANSACTION_STATUS = {
  unbilled: 'unbilled',
  invoiced: 'invoiced',
};

export const INVOICE_STATUS = {
  reconciled: 'reconciled',
  draft: 'draft',
  sent: 'sent',
  overdue: 'overdue',
};

export const SOURCE = {
  hospitable: 'hospitable',
  manual: 'manual',
};
